const Systems ="vipcg" 


export default Systems;
